export default class PaginationResult<Type> {
    
    constructor(
        public rows: Array<Type>,
        public total: number
    ) {
        
    }
}